var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tk-switch"},[_c('div',{staticClass:"tk-switch-name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('pot-switch',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }